const types = {
  ADD_CART_SUCCESS: 'ADD_CART_SUCCESS',
}
export default types;